<ion-header class="ion-no-border">

  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-button (click)="close()">
        <fa-icon [icon]="['far', 'times']" size="lg" [fixedWidth]="true" slot="start"></fa-icon>
      </ion-button>
    </ion-buttons>
    <ion-title>
      Add fulfillment
      @if (order) {
        <p class="subtitle">Order #{{order.number}}</p>
      }
    </ion-title>
    @if (online && !loading) {
      <ion-buttons slot="end">
        <ion-button (click)="add()">
          <fa-icon [icon]="['far', 'check']" size="lg" [fixedWidth]="true" slot="start"></fa-icon>
        </ion-button>
      </ion-buttons>
    }
  </ion-toolbar>

</ion-header>

<ion-content>

  @if (online && !loading && order) {
    <ion-grid class="form">
      @if (order_payment_owing || customer_amount_owing || customer_credit_limit_exceeded) {
        <ion-row>
          <ion-col>
            <div class="warning-box">
              @if (order_payment_owing) {
                <p>There is <strong>{{order.currency.sign}}{{order.amount_due | number:'1.2'}} {{order.currency.code}}</strong> left to be paid on this order.</p>
              }
              @if (customer_amount_owing) {
                <p>
                  @if (order.organisation) {
                    <span>The customer currently owes you <strong>{{base_currency.sign}}{{order.organisation.amount_owing | number:'1.2'}} {{order.currency.code}}</strong>.</span>
                  }
                  @if (!order.organisation) {
                    <span>The customer currently owes you <strong>{{base_currency.sign}}{{order.person.amount_owing | number:'1.2'}} {{order.currency.code}}</strong>.</span>
                  }
                </p>
              }
              @if (customer_credit_limit_exceeded) {
                <p>
                  @if (order.organisation) {
                    <span>The customer has exceeded their credit limit of <strong>{{base_currency.sign}}{{order.organisation.credit_limit | number:'1.2'}} {{order.currency.code}}</strong>.</span>
                  }
                  @if (!order.organisation) {
                    <span>The customer has exceeded their credit limit of <strong>{{base_currency.sign}}{{order.person.credit_limit | number:'1.2'}} {{order.currency.code}}</strong>.</span>
                  }
                </p>
              }
            </div>
          </ion-col>
        </ion-row>
      }
      <ion-row>
        <ion-col>
          <ion-grid class="fieldset">
            <ion-row>
              <ion-col>
                <ion-select okText="OK" interface="alert" [interfaceOptions]="method_select_options" labelPlacement="stacked" fill="outline" [(ngModel)]="fulfillment_params['method']">
                  <div slot="label">Method</div>
                  <ion-select-option value="collected">Collected</ion-select-option>
                  <ion-select-option value="shipped">Shipped</ion-select-option>
                  <ion-select-option value="dropshipped">Dropshipped</ion-select-option>
                </ion-select>
              </ion-col>
            </ion-row>
            @if (locations && fulfillment_params['method'] != 'dropshipped') {
              <ion-row>
                <ion-col>
                  <ion-select okText="OK" interface="alert" [interfaceOptions]="location_select_options" labelPlacement="stacked" fill="outline" [(ngModel)]="fulfillment_params['location_id']">
                    <div slot="label">Location</div>
                    @for (location of locations; track location) {
                      <ion-select-option value="{{location.id}}">{{location.title}}</ion-select-option>
                    }
                  </ion-select>
                </ion-col>
              </ion-row>
            }
          </ion-grid>
          <ion-grid class="fieldset">
            <ion-row>
              <ion-col>
                <h3>Items to fulfill</h3>
              </ion-col>
            </ion-row>
            <ion-row>
              <ion-col>
                <ion-grid class="ion-no-padding">
                  @for (item of fulfillable_items; track item) {
                    @if (item.fulfillable_quantity > 0) {
                      <ion-row class="quantity-row">
                        <ion-col>
                          <ion-grid class="ion-no-padding">
                            <ion-row>
                              <ion-col size="auto">
                                <h5>Item</h5>
                                <p class="prominent">{{item.title}}</p>
                              </ion-col>
                            </ion-row>
                            @if (item.sku) {
                              <ion-row>
                                <ion-col size="auto">
                                  <h5>SKU</h5>
                                  <p class="prominent">{{item.sku}}</p>
                                </ion-col>
                              </ion-row>
                            }
                            @if (item.track_stock) {
                              <ion-row>
                                <ion-col size="auto">
                                  <h5>Stock on hand</h5>
                                  <p class="badges ion-text-wrap">
                                    @if (item.stock_on_hand == 0) {
                                      <ion-badge color="danger">{{item.stock_on_hand}}</ion-badge>
                                    }
                                    @if (item.stock_on_hand != 0 && item.fulfillable_quantity > item.stock_on_hand) {
                                      <ion-badge color="warning">{{item.stock_on_hand}}</ion-badge>
                                    }
                                    @if (item.stock_on_hand >= item.fulfillable_quantity) {
                                      <ion-badge color="success">{{item.stock_on_hand}}</ion-badge>
                                    }
                                  </p>
                                </ion-col>
                              </ion-row>
                            }
                          </ion-grid>
                        </ion-col>
                        <ion-col size="auto" class="ion-text-center">
                          <div>
                            <h5>Quantity@if (item.measurement_unit) {
                              ({{item.measurement_unit.symbol}})
                            }</h5>
                            <fa-icon size="lg" [icon]="['fas', 'minus']" (click)="adjustItemQuantity(item.id,'subtract')"></fa-icon><span class="clickable-text" (click)="editItemQuantity(item)">{{item.quantity}} of {{item.fulfillable_quantity}}</span><fa-icon size="lg" [icon]="['fas', 'plus']" (click)="adjustItemQuantity(item.id,'add')"></fa-icon>
                          </div>
                        </ion-col>
                      </ion-row>
                    }
                  }
                </ion-grid>
              </ion-col>
            </ion-row>
            @if ((printer_paper_sizes && printer_paper_sizes.includes('a4')) && fulfillable_items.length != 0) {
              <ion-row>
                <ion-col>
                  <p><a (click)="printPackingSlip()" style="cursor: pointer;"><fa-icon [icon]="['fal', 'print']"></fa-icon>Print packing slip</a></p>
                </ion-col>
              </ion-row>
            }
          </ion-grid>
          @if (fulfillment_params['method'] == 'shipped') {
            <ion-grid class="fieldset">
              @if (order.special_instructions) {
                <ion-row>
                  <ion-col>
                    <h5>Special instructions</h5>
                    <p class="prominent">{{order.special_instructions}}</p>
                  </ion-col>
                </ion-row>
              }
              <ion-row>
                <ion-col>
                  <h5>Gift</h5>
                  @if (order.gift == true) {
                    <p class="prominent">Yes</p>
                  }
                  @if (order.gift == false) {
                    <p class="prominent">No</p>
                  }
                </ion-col>
              </ion-row>
              @if (order.gift_message) {
                <ion-row>
                  <ion-col>
                    <h5>Gift message</h5>
                    <p class="prominent">{{order.gift_message}}</p>
                  </ion-col>
                </ion-row>
              }
            </ion-grid>
          }
          @if ((order.shipping_address || order.shipping_rate || order.shipping) && fulfillment_params['method'] == 'shipped') {
            <ion-grid class="fieldset">
              @if (order.shipping_address) {
                <ion-row>
                  <ion-col>
                    <h5>Shipping address</h5>
                    @if (order.shipping_address.first_name || order.shipping_address.last_name) {
                      <p class="prominent">
                        @if (order.shipping_address.first_name) {
                          <span>{{order.shipping_address.first_name}}</span>
                        }
                        @if (!order.shipping_address.first_name && order.shipping_address.last_name) {
                          <span>&nbsp;</span>
                        }
                        @if (order.shipping_address.last_name) {
                          <span>{{order.shipping_address.last_name}}</span>
                        }
                      </p>
                    }
                    @if (order.shipping_address.organisation_title) {
                      <p class="prominent">{{order.shipping_address.organisation_title}}</p>
                    }
                    @if (order.shipping_address.premises) {
                      <p class="prominent">{{order.shipping_address.premises}}</p>
                    }
                    @if (order.shipping_address.line_1) {
                      <p class="prominent">{{order.shipping_address.line_1}}</p>
                    }
                    @if (order.shipping_address.line_2) {
                      <p class="prominent">{{order.shipping_address.line_2}}</p>
                    }
                    @if (order.shipping_address.locality) {
                      <p class="prominent">{{order.shipping_address.locality}}</p>
                    }
                    @if (order.shipping_address.subdivision) {
                      <p class="prominent">{{order.shipping_address.subdivision}}</p>
                    }
                    @if (order.shipping_address.postal_code) {
                      <p class="prominent">{{order.shipping_address.postal_code}}</p>
                    }
                    @if (order.shipping_address.country) {
                      <p class="prominent">{{order.shipping_address.country.title}}</p>
                    }
                  </ion-col>
                </ion-row>
                @if (order.shipping_address.what3words_address) {
                  <ion-row>
                    <ion-col>
                      <h5>what3words address</h5>
                      <p class="prominent">///{{order.shipping_address.what3words_address}}</p>
                    </ion-col>
                  </ion-row>
                }
                @if (order.shipping_address.courier_instructions) {
                  <ion-row>
                    <ion-col>
                      <h5>Courier instructions</h5>
                      <p class="prominent">{{order.shipping_address.courier_instructions}}</p>
                    </ion-col>
                  </ion-row>
                }
                @if (order.shipping_address.mobile_phone_number) {
                  <ion-row>
                    <ion-col>
                      <h5>Mobile phone number</h5>
                      <p class="prominent">{{order.shipping_address.mobile_phone_number}}</p>
                    </ion-col>
                  </ion-row>
                }
              }
              @if (order.shipping_rate) {
                <ion-row>
                  <ion-col>
                    <h5>Shipping rate</h5>
                    <p class="prominent">{{order.shipping_rate.internal_name}}</p>
                  </ion-col>
                </ion-row>
              }
              @if (order.shipping) {
                <ion-row>
                  <ion-col>
                    <h5>Shipping price</h5>
                    <p class="prominent">{{order.shipping.price | currency:order.currency.code:'symbol-narrow':'1.2-2'}}</p>
                  </ion-col>
                </ion-row>
              }
            </ion-grid>
          }
          @if (fulfillment_params['method'] == 'shipped' || fulfillment_params['method'] == 'dropshipped') {
            <ion-grid class="fieldset">
              <ion-row>
                <ion-col>
                  <ion-select cancelText="Clear" okText="OK" (ionCancel)="clearCourier()" interface="alert" [interfaceOptions]="courier_select_options" labelPlacement="stacked" fill="outline" [(ngModel)]="fulfillment_params['courier_id']">
                    <div slot="label">Courier<ion-text class="optional">optional</ion-text></div>
                    @for (courier of couriers; track courier) {
                      <ion-select-option value="{{courier.id}}">{{courier.title}}</ion-select-option>
                    }
                  </ion-select>
                </ion-col>
              </ion-row>
              <ion-row>
                <ion-col>
                  <ion-input type="tel" inputmode="decimal" maxlength="100" labelPlacement="stacked" fill="outline" [(ngModel)]="fulfillment_params['courier_tracking_number']">
                    <div slot="label">Courier tracking number<ion-text class="optional">optional</ion-text></div>
                  </ion-input>
                </ion-col>
              </ion-row>
            </ion-grid>
          }
          @if ((fulfillment_params['method'] == 'shipped' || fulfillment_params['method'] == 'dropshipped') && ((order.person && order.person.email_address) || order.shipping_notification_email_address)) {
            <ion-grid class="fieldset">
              @if (order.shipping_notification_email_address) {
                <ion-row>
                  <ion-col>
                    <div class="warning-box">
                      <p>A shipping notification email address has been provided for this order. The "order shipped" email will be sent to this address. Be aware that this may not be to the person who placed the order.</p>
                    </div>
                  </ion-col>
                </ion-row>
              }
              @if (order.person && order.person.email_address) {
                <ion-row>
                  <ion-col>
                    <h5>Person</h5>
                    @if (order.person.full_name) {
                      <p class="prominent">{{order.person.full_name}} (#{{order.person.number}})</p>
                    }
                    @if (!order.person.full_name) {
                      <p class="prominent">#{{order.person.number}}</p>
                    }
                  </ion-col>
                </ion-row>
                <ion-row>
                  <ion-col>
                    <h5>Order count</h5>
                    <p class="prominent">{{order.person.order_count}}</p>
                  </ion-col>
                </ion-row>
              }
              <ion-row>
                <ion-col>
                  <ion-textarea type="text" inputmode="text" maxlength="1000" [autoGrow]="true" rows="5" labelPlacement="stacked" fill="outline" [(ngModel)]="fulfillment_params['customer_note']">
                    <div slot="label">Note to customer<ion-text class="optional">optional</ion-text></div>
                  </ion-textarea>
                </ion-col>
              </ion-row>
              <ion-row>
                <ion-col>
                  <ion-item lines="none" class="ion-no-padding">
                    <ion-toggle class="form-toggle" alignment="start" label-placement="stacked" [(ngModel)]="fulfillment_params.send_order_shipped_email">Send order shipped email</ion-toggle>
                  </ion-item>
                </ion-col>
              </ion-row>
            </ion-grid>
          }
          <ion-grid class="fieldset">
            <ion-row >
              <ion-col>
                @if (fulfillment_params['date']) {
                  <ion-input class="modal-input" readonly="true" label="Date" labelPlacement="stacked" fill="outline" value={{formatted_date}} (click)="presentDateTimePickerModal()"></ion-input>
                }
                @if (!fulfillment_params['date']) {
                  <ion-input class="modal-input" readonly="true" label="Date" labelPlacement="stacked" fill="outline" (click)="presentDateTimePickerModal()"></ion-input>
                }
              </ion-col>
            </ion-row>
          </ion-grid>
        </ion-col>
      </ion-row>
    </ion-grid>
  }

</ion-content>